import { LitElement, html, css } from 'lit-element';
import { LinkStyles } from '../styles/link-styles';

class TmnPackagesCellFormatter extends LitElement {
    static get styles() {
        return [
            LinkStyles.styles,
            css`
                .error-message {
                    max-width: 400px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .details-content {
                    display: flex;
                    flex-direction: column;
                    line-height: 1.4;
                }

                .details-row {
                    display: flex;
                    flex-direction: row;
                }

                .description {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    vertical-align: bottom;
                }
                .link-error {
                    color: var(--app-error-color);
                    width: max-content;
                }
                ol {
                    list-style-type: decimal;
                }

                li {
                    width: max-content;
                }

                li > div,
                li > a {
                    display: inline-block;
                }
            `,
        ];
    }

    static get properties() {
        return {
            value: {
                type: Object,
            },
            row: {
                type: Object,
            },
            format: {
                type: String,
            },
        };
    }

    // changes in renderDataRow are mostly to deal with the error message being possibly really long
    render() {
        const { row, value, format } = this;
        if (format === 'error-message') {
            return html`<div class="error-message">
                ${Array.isArray(value) ? value.join(', ') : value}
            </div>`;
        }
        if (format === 'details') {
            const { details } = row.metaData.rawData;

            return html`<ol class="details-content">
                ${details?.content.map((c) => {
                    const link = c.data?.[0]?.url;
                    return html`<li>
                        <div class="description" title="${c.description}">${c.description}</div>
                        ${link
                            ? html`<a target="_blank" href="${link}">Link</a>`
                            : html`<div class="link-error">Empty URL</div>`}
                    </li>`;
                })}
            </ol>`;
        }
    }
}

window.customElements.define('tmn-packages-cell-formatter', TmnPackagesCellFormatter);
